import LoadScene from '@scenes/LoadScene';
import StartScene from '@scenes/StartScene';
import GetCoinScene from '@scenes/GetCoinScene';
import GameScene, { DemoScene } from '@scenes/GameScene';
import EndScene from '@scenes/EndScene';

export default [
  { key: 'LoadScene', scene: LoadScene, autoStart: true },
  { key: 'StartScene', scene: StartScene },
  { key: 'GetCoinScene', scene: GetCoinScene },
  { key: 'GameScene', scene: GameScene },
  { key: 'DemoScene', scene: DemoScene },
  { key: 'EndScene', scene: EndScene },
];
